import { CommonTooltips } from "@mcleod/common";
import { Component } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";

export class CollectionsUtil {
    static setTooltipContent(component: Component, modelRow: ModelRow) {
        switch (component.id) {
            case "labelCustomerName":
            case "imageHasBridgeAccount": {
                if (!modelRow.isNull("customer_id")) {
                    CommonTooltips.setTooltipContentLayout(component, modelRow.getString("customer_id"), "lme/ar/CustomerQuickInfo");
                }
                break;
            }
        }
    }
}
